module.exports = __webpack_public_path__ + "img/score6.8702d436.png";